import { Checkbox, FormControlLabel } from '@mui/material'
import React, { ChangeEvent, MouseEventHandler } from 'react'
import { Control, Controller, UseFormSetValue } from 'react-hook-form'

type FormCheckboxProps = {
  name: string
  label: string
  control: Control<any>
  setValue: UseFormSetValue<any>
  onClick?: MouseEventHandler<HTMLButtonElement>
  disabled?: boolean
}

const FormCheckbox: React.FC<FormCheckboxProps> = ({
  name,
  label,
  control,
  setValue,
  onClick,
  disabled,
}) => {
  const handleChange = (e: ChangeEvent<HTMLInputElement>, onChange: (...event: any[]) => void) => {
    const isChecked = e.target.checked
    const choiceChecked = isChecked ? 'S' : 'N'
    onChange(choiceChecked)
    setValue(name, choiceChecked)
  }

  return (
    <Controller
      name={name}
      control={control}
      render={({ field: { value: value, onChange } }) => (
        <FormControlLabel
          control={
            <Checkbox
              size='small'
              color='secondary'
              checked={value === 'S'}
              onChange={(e) => handleChange(e, onChange)}
              onClick={onClick}
              disabled={disabled}
            />
          }
          value={value || 'N'}
          label={label}
        />
      )}
    />
  )
}

export default FormCheckbox
